function getMultimediaState(state) {
  return {
    getMultimediaLoading: state.multimediaStep.getMultimediaLoading,
    getMultimediaError: state.multimediaStep.getMultimediaError,
    getMultimediaCompleted: state.multimediaStep.getMultimediaCompleted
  };
}

function getPictures(state) {
  // Se usa para visualizar las imagenes con o sin error.
  const imagesToShow = state.multimediaStep.multimedias.pictures.filter(picture => !picture.delete);
  return { images: imagesToShow };
}

function getValidPictures(state) {
  // Se usa para validar las imagenes sin error y con temporalUrl. Esto para poder determinar si hay cambios con respecto a los valores iniciales
  const images = state.multimediaStep.multimedias.pictures.filter(
    picture => !picture.delete && !picture.error && (picture.temporalUrl || picture.url)
  );
  return { images };
}

function getPlans(state) {
  // Se usa para visualizar los planos con o sin error.
  const plansToShow = state.multimediaStep.multimedias.plan.filter(picture => !picture.delete);
  return { plans: plansToShow };
}

function getValidPlans(state) {
  // Se usa para validar los planos sin error y con temporalUrl. Esto para poder determinar si hay cambios con respecto a los valores iniciales
  const plans = state.multimediaStep.multimedias.plan.filter(
    picture => !picture.delete && !picture.error && (picture.temporalUrl || picture.url)
  );
  return { plans };
}

function getVideos(state) {
  return { videos: state.multimediaStep.multimedias.videos.filter(videos => !videos.delete) };
}

function getVideos360(state) {
  return { tour360: state.multimediaStep.multimedias.tour360.filter(video => !video.delete) };
}

function validate(state) {
  // Se arma la data para validar el esquema formSchema
  return {
    pictures: state.multimediaStep.multimedias.pictures
      ? state.multimediaStep.multimedias.pictures.filter(picture => !picture.delete && !picture.error)
      : null,
    videos: state.multimediaStep.multimedias.videos
      ? state.multimediaStep.multimedias.videos.filter(video => !video.delete)
      : null,
    tour360: state.multimediaStep.multimedias.tour360
      ? state.multimediaStep.multimedias.tour360.filter(tour360 => !tour360.delete)
      : null,
    plans: state.multimediaStep.multimedias.plan
      ? state.multimediaStep.multimedias.plan.filter(plan => !plan.delete && !plan.error)
      : null
  };
}

function onlyValidPictures(arr = []) {
  // Dado que las imagenes o planos se pueden visualizar con error o sin una temporalUrl o url (se muestra defaultImage) validamos el error y la url
  return arr.filter(p => !p.error && (p.temporalUrl || p.url));
}

function stepData(state) {
  // Armamos la data que se envía en el body
  return {
    pictures: [
      ...onlyValidPictures(state.multimediaStep.multimedias.pictures),
      ...onlyValidPictures(state.multimediaStep.multimedias.plan)
    ],
    videos: [...state.multimediaStep.multimedias.videos, ...state.multimediaStep.multimedias.tour360]
  };
}

function getSavedMedia(state) {
  return { originalMultimedia: state.multimediaStep.originalMultimedia };
}

function validateVideo360State(state) {
  return {
    validation360Loading: state.multimediaStep.validation360Loading,
    validationVideo360Success: state.multimediaStep.validationVideo360Success,
    validationVideo360Error: state.multimediaStep.validationVideo360Error,
    validatedVideo360: state.multimediaStep.validatedVideo360
  };
}

function getPreviewStorageStateById(state, itemId) {
  // Usamos para mostrar el loader dentro de cada image al momento de generar la preview.
  const imageState = state.multimediaStep.previewStorageItems[itemId] || {};
  return {
    previewStorageLoading: imageState.previewStorageLoading || false,
    response: imageState.response || null,
    previewStorageError: imageState.previewStorageError || false
  };
}

function getPreviewStorageLoading(state) {
  // Es true cuando alguna de las nuevas imagenes tiene el loader activo.
  const imageState = state.multimediaStep.previewStorageItems;
  return Object.values(imageState)?.some(item => item.previewStorageLoading);
}

export {
  getPictures,
  validate,
  stepData,
  getVideos,
  getPlans,
  getVideos360,
  getValidPictures,
  getValidPlans,
  getSavedMedia,
  getMultimediaState,
  validateVideo360State,
  getPreviewStorageStateById,
  getPreviewStorageLoading
};
